/* eslint-disable no-magic-numbers -- surface tokens are named by number */

import styled from 'styled-components';

export const OnboardingWizardRoot = styled.div`
	display: flex;
	flex-direction: row;
	border-radius: 4px;
	overflow: hidden;
	background: ${({ theme }) => theme.surface[2]};
	font-family: ${({ theme }) => theme.font};
`;

export const OnboardingWizardSidebar = styled.div`
	padding: 16px;
	border-right: 1px solid ${({ theme }) => theme.border.decorative};
	min-width: 180px;
`;

export const OnboardingWizardContent = styled.div`
	flex: 1;
	padding: 16px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`;

export const OnboardingWizardContentHeader = styled.h3`
	margin: 0;
	font-size: 16px;
	font-weight: 600;
	line-height: 140%;
	color: ${({ theme }) => theme.text.primary};
`;

export const OnboardingWizardContentBody = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 16px;

	p {
		flex: 1;
		margin: 0;
		font-size: 14px;
		line-height: 1.5;
		color: ${({ theme }) => theme.text.secondary};
	}
`;
